import * as React from 'react';

import { Segment } from './applyRule.ts';
import classnames from '../../../core/utils/classnames.tsx';

interface ChipProps extends React.ComponentPropsWithRef<'span'> {
    change: Segment['type'];
}

export const Chip = ({ change, className, ...props }: ChipProps) => (
    <span
        {...props}
        className={classnames(
            'inline-flex items-center rounded border border-solid px-1.5 text-xs',
            change === 'added' && 'border-transparent bg-surface-success-weak text-content-success-strong',
            change === 'removed' && 'border-transparent bg-surface-danger-weak text-content-danger-strong line-through',
            change === 'same' && 'border-line-weak text-content-strong',
            className
        )}
    />
);

const getListChange = (item: string, before: string[], after: string[]): Segment['type'] => {
    if (!before.includes(item)) return 'added';
    if (!after.includes(item)) return 'removed';
    return 'same';
};

interface ListChipsProps {
    before: string[];
    after: string[];
}

export const ListChips = ({ before, after }: ListChipsProps) => (
    <span className="flex flex-wrap gap-1.5">
        {[...new Set([...before, ...after])].toSorted().map((item) => (
            <Chip key={item} change={getListChange(item, before, after)}>
                {item}
            </Chip>
        ))}
    </span>
);
